export enum AemContentType {
	HEADER = 'Header',
	FOOTER = 'Footer',
}
